function initFlexibleAssetVideo(wrap) {
  const video = wrap.querySelector('video');
  const playButton = wrap.querySelector('[data-flex-video-play]');
  if (!video || !playButton) return;

  const showFallback = () => {
    wrap.classList.add('is-fallback');
  };

  const hideFallback = () => {
    wrap.classList.remove('is-fallback');
  };

  const tryAutoplay = () => {
    video.muted = true;
    video.playsInline = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise
        .then(() => {
          hideFallback();
        })
        .catch(() => {
          showFallback();
        });
    } else if (video.paused) {
      showFallback();
    }
  };

  video.addEventListener('error', showFallback);
  video.addEventListener('loadeddata', tryAutoplay);
  video.addEventListener('playing', hideFallback);

  playButton.addEventListener('click', () => {
    video.controls = true;
    video.muted = false;
    const clickPlayPromise = video.play();
    if (clickPlayPromise && typeof clickPlayPromise.catch === 'function') {
      clickPlayPromise
        .then(() => {
          hideFallback();
        })
        .catch(() => {
          showFallback();
        });
    }
  });

  if (video.readyState >= 2) {
    tryAutoplay();
  }
}

function initFlexibleAssets() {
  document.querySelectorAll('[data-flex-video]').forEach((wrap) => {
    if (wrap.dataset.flexVideoReady === 'true') return;
    wrap.dataset.flexVideoReady = 'true';
    initFlexibleAssetVideo(wrap);
  });
}

initFlexibleAssets();
document.addEventListener('shopify:section:load', initFlexibleAssets);

